// src/Utils/AnnouncementsUtil.js

/** Muuttaa announcement-entiteetin editorin draft-muotoon turvallisesti. */
export function normalizeAnnouncement(entity) {
  const x = entity || {};
  return {
    id: x.id ?? null,
    title: x.title || "",
    content: x.content || "",
    category: x.category || "",
    audience: x.audience || "residents_owners",
    attachments: Array.isArray(x.attachments) ? x.attachments : [],
    createdAt: x.createdAt || null,
    updatedAt: x.updatedAt || null,
    comments: Array.isArray(x.comments)
      ? x.comments
      : Array.isArray(x.messages)
      ? x.messages
      : [],
  };
}

/** Palauttaa true jos draftissa on muutoksia suhteessa baseen (tallennus tarpeen). */
export function computeAnnouncementDirty(draft, base) {
  if (!base) return true;

  return (
    (draft.title || "") !== (base.title || "") ||
    (draft.content || "") !== (base.content || "") ||
    (draft.category || "") !== (base.category || "") ||
    (draft.audience || "residents_owners") !==
      (base.audience || "residents_owners")
  );
}

/** Yhdistää serveriltä tulleet kommentit ja optimistiset kommentit niin, ettei optimistinen häviä refetcheissä. */
export function mergeCommentsKeepOptimistic(prevComments, nextComments) {
  const prevArr = Array.isArray(prevComments) ? prevComments : [];
  const nextArr = Array.isArray(nextComments) ? nextComments : [];
  const nextIds = new Set(nextArr.filter(Boolean).map((c) => String(c?.id)));

  const keepOptimistic = prevArr.filter(
    (c) => c && c._optimistic && c.id != null && !nextIds.has(String(c.id))
  );

  const merged = [...nextArr, ...keepOptimistic];
  merged.sort((a, b) => (a?.createdAt || 0) - (b?.createdAt || 0));
  return merged;
}

export function getAttachmentCount(a) {
  if (Array.isArray(a.attachments)) return a.attachments.length;
  if (Array.isArray(a.files)) return a.files.length;
  if (Array.isArray(a.attachmentUrls)) return a.attachmentUrls.length;
  if (Array.isArray(a.liitteet)) return a.liitteet.length;
  return a.hasAttachments ? 1 : 0;
}